import { render, staticRenderFns } from "./RmsSettings.vue?vue&type=template&id=5b2a79e0"
import script from "./RmsSettings.vue?vue&type=script&lang=js"
export * from "./RmsSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports